import { useTranslation } from 'react-i18next';
import { ClientOffer } from 'hooks/webapi/client/useClientOfferQuery';
import { dateFormat, numberToCurrency, numberToPercent } from 'utils/translate';

export default function UpsaleOffer({
  isLoading,
  offer,
}: {
  isLoading?: boolean;
  offer?: ClientOffer;
}) {
  const { t } = useTranslation('upsale');
  return (
    <div className="my-5 w-full">
      <div
        className="border-b flex justify-between py-2"
        data-test="upsaleCard-row-loan"
      >
        <span data-test="upsaleCard-row-loan-text">{t('table.loan')}</span>
        <div
          className="text-primary font-semibold text-lg"
          data-test="upsaleCard-row-loan-number"
        >
          {isLoading || !offer ? (
            <div className="animate-pulse bg-background-accent w-52 h-7" />
          ) : (
            numberToCurrency(offer.newPrincipal)
          )}
        </div>
      </div>

      <div
        className="border-b flex justify-between py-2"
        data-test="upsaleCard-row-mtp"
      >
        <span data-test="upsaleCard-row-mtp-text">{t('table.mtp')}</span>
        <div
          className="text-primary font-semibold text-lg"
          data-test="upsaleCard-row-mtp-number"
        >
          {isLoading || !offer ? (
            <div className="animate-pulse bg-background-accent w-52 h-7" />
          ) : (
            <span data-test="minimum-to-pay">
              {numberToCurrency(offer?.loanExtensionFees[0].fee)}
            </span>
          )}
        </div>
      </div>

      <div
        className="border-b flex justify-between py-2"
        data-test="upsaleCard-row-loan-futureExtensionFees"
      >
        <span data-test="upsaleCard-row-loan-futureExtensionFees-text">
          {t('table.futureExtensionFees')}
        </span>
        <div
          className="text-primary font-semibold text-lg"
          data-test="upsaleCard-row-loan-futureExtensionFees-number"
        >
          {isLoading || !offer ? (
            <div className="animate-pulse bg-background-accent w-52 h-7" />
          ) : (
            numberToCurrency(offer.futureExtensionFees[0].fee)
          )}
        </div>
      </div>

      <div
        className="border-b flex justify-between py-2"
        data-test="upsaleCard-row-rate"
      >
        <span data-test="upsaleCard-row-rate-text">{t('table.interest')}</span>
        <div
          className="text-primary font-semibold text-lg"
          data-test="upsaleCard-row-rate-number"
        >
          {isLoading || !offer ? (
            <div className="animate-pulse bg-background-accent w-20 h-7" />
          ) : (
            <span data-test="interest">
              {numberToPercent(offer?.interestRate, 2)}
            </span>
          )}
        </div>
      </div>

      <div
        className="flex justify-between py-2"
        data-test="upsaleCard-row-date"
      >
        <span data-test="upsaleCard-row-date-text">{t('table.due_date')}</span>
        <div
          className="text-primary font-semibold text-lg"
          data-test="upsaleCard-row-date-number"
        >
          {isLoading || !offer ? (
            <div className="animate-pulse bg-background-accent w-32 h-7" />
          ) : (
            <span data-test="offer-first-payment-date">
              {dateFormat(offer?.firstPaymentDate)}
            </span>
          )}
        </div>
      </div>
      <div
        className="text-[#606469] text-sm mt-4"
        data-test="offer-loan-example"
        dangerouslySetInnerHTML={{ __html: t('loan_example') }}
      />
    </div>
  );
}
